import { useSelector } from 'react-redux';
import { useMemo, useEffect } from 'react';
import { get } from 'lodash';

import { useUser, useActions, useFetching } from '@mssgme/hooks';
import { getFilteredAndSortedConversations } from '@mssgme/store';

export default function useConversationList() {
    const { api } = useActions();
    const user = useUser();
    const { conversations, hasMore, next } = useSelector((state) => {
        const { hasNext, next } = state.conversations.list;

        return {
            conversations: getFilteredAndSortedConversations(state),
            hasMore: hasNext,
            next,
        };
    });

    const loadConversations = useFetching(api.conversations.filterList);

    useEffect(() => {
        loadConversations.run();
    }, []);

    const items = useMemo(
        () =>
            conversations.map(({ contact, blocked, read, lastMessage }) => {
                const isMessageUpcoming =
                    lastMessage && lastMessage.authorKind === 'User' && lastMessage.author === user._id;
                const messageType = get(lastMessage, 'type');
                const messageText = get(lastMessage, 'text', '');

                let text;

                switch (messageType) {
                    case 'image':
                        text = 'Image';
                        break;
                    case 'file':
                        text = 'File';
                        break;
                    case 'text':
                        text = messageText;
                        break;
                    default:
                        text = 'Unsupported';
                }

                return {
                    id: contact.id,
                    avatar: contact.avatarUrl,
                    username: contact.name,
                    lastMessage: text,
                    lastActivity: lastMessage.received,
                    isMessageUpcoming: isMessageUpcoming,
                    isNew: !read,
                    isBlocked: !!blocked,
                    platform: contact.client.platform,
                };
            }),
        [conversations]
    );

    const onScroll = ({ target }) => {
        const max = target.scrollHeight - target.clientHeight - 200;

        if (hasMore && target.scrollTop >= max) {
            loadConversations.run({ query: { next } });
        }
    };

    return { items, hasMore, onScroll };
}
